import { Schemas } from '~/api/gen'
import { MemberCarouselList } from '~/features/shared/components/member/MemberCarouselList'

type Props = {
  members: Schemas.official_recommended_member_with_member[]
}

export const PopularUsers: React.FC<Props> = ({ members }) => {
  return (
    <div className="flex flex-col gap-[15px] xl:gap-[2px]">
      <h2 className="text-[18px] font-bold leading-[1.4]">人気のユーザー</h2>
      <div className="flex flex-col gap-3 xl:gap-4">
        <MemberCarouselList members={members.map((member) => member.member)} />
        <p className="pr-[15px] text-right xl:p-0">
          <a
            href="/ranking/user/"
            className="text-[13px] font-bold text-blue-400 xl:text-[14px] xl:hover:underline"
          >
            ユーザーランキングを見る
          </a>
        </p>
      </div>
    </div>
  )
}
